export const OrderUnitTypes = {
  Standard: "Standard",
  Display: "Display",
  Aktion: "Aktion",
};

export const allowedOrderUnitsFilter = (allOrderUnits, selectedUnits) =>
  Object.keys(allOrderUnits)
    ?.filter(
      key =>
        allOrderUnits[key].isLive &&
        allOrderUnits[key].orderUnitType !== OrderUnitTypes.Aktion &&
        !selectedUnits?.some(x => x?.orderUnit?.id === allOrderUnits[key]?.id),
    )
    .map(key => allOrderUnits[key]) ?? [];

export const allowedFreeOrderUnitsFilter = (allOrderUnits, selectedFreeUnits) =>
  Object.keys(allOrderUnits)
    ?.filter(
      key =>
        allOrderUnits[key].isLive &&
        allOrderUnits[key].orderUnitType !== OrderUnitTypes.Aktion &&
        !selectedFreeUnits?.some(
          x => x?.orderUnit?.id === allOrderUnits[key]?.id,
        ),
    )
    .map(key => allOrderUnits[key]) ?? [];
